import { CardBrand } from './card-brand';
export const getCardNumberMaxLengthByBrand = (cardBrand) => {
    switch (cardBrand) {
        case CardBrand.Visa:
        case CardBrand.Maestro:
            return 23;
        case CardBrand.American:
            return 18;
        default:
            return 19;
    }
};
//# sourceMappingURL=get-card-number-max-length-by-brand.js.map